import React from 'react';
import { getCountryFlagUrl } from '../eimDashboardUtils';

type CountryFlagLabelProps = {
    countryCode?: string | null;
    label: React.ReactNode;
    className?: string;
    flagClassName?: string;
    flagSize?: number;
    title?: string;
};

const CountryFlagLabel = ({
    countryCode,
    label,
    className,
    flagClassName,
    flagSize = 18,
    title,
}: CountryFlagLabelProps) => {
    const src = getCountryFlagUrl(countryCode);
    const normalizedCountryCode = String(countryCode ?? '').trim().toUpperCase();
    const labelTitle = title ?? normalizedCountryCode;

    return (
        <span
            className={className}
            title={labelTitle}
            style={{
                alignItems: 'center',
                display: 'inline-flex',
                gap: 8,
                minWidth: 0,
            }}
        >
            <span
                className={flagClassName}
                aria-hidden="true"
                style={{
                    alignItems: 'center',
                    backgroundColor: '#f3f4f6',
                    borderRadius: 999,
                    display: 'inline-flex',
                    flexShrink: 0,
                    height: flagSize,
                    justifyContent: 'center',
                    overflow: 'hidden',
                    width: flagSize,
                }}
            >
                {src ? (
                    <img
                        alt={labelTitle}
                        src={src}
                        style={{
                            display: 'block',
                            height: '100%',
                            objectFit: 'cover',
                            width: '100%',
                        }}
                        onError={(event) => {
                            const target = event.currentTarget;
                            target.style.display = 'none';
                        }}
                    />
                ) : null}
            </span>
            <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {label}
            </span>
        </span>
    );
};

export default CountryFlagLabel;
